import firehydrantAPI from 'helpers/firehydrantAPI';
import { useMutation, useQuery } from 'react-query';

export const useSignalNotifications = () => {
  const query = useQuery(['signals_notification_settings'], () =>
    firehydrantAPI.get('signals_notification_settings', {}),
  );

  return {
    ...query,
    data: query.data?.data?.data,
  };
};

export const useSignalDestinations = () => {
  const query = useQuery(['signals_notification_destinations'], () =>
    firehydrantAPI.get('signals/destinations', {}),
  );

  return {
    ...query,
    data: query.data?.data?.data,
  };
};

export const createSignalsNotification = (params) =>
  firehydrantAPI.post('signals_notification_settings', params);

export const useCreateSignalsNotification = (params) =>
  useMutation(createSignalsNotification, params);

const updateSignalsNotification = (params) =>
  firehydrantAPI.patch(`signals_notification_settings/${params.id}`, params);

export const useUpdateSignalsNotification = (params) => {
  return useMutation(updateSignalsNotification, params);
};

const deleteSignalsNotification = (params) =>
  firehydrantAPI.delete(`signals_notification_settings/${params.id}`);

export const useDeleteSignalsNotification = (params) => {
  return useMutation(deleteSignalsNotification, params);
};
